/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { LenderTable, Text } from '@blend/enterprise-components';

export namespace AutoTaggingFailures {
  export interface Props {
    auditEvents: EClose.AuditEventResponse[];
  }
}

/** AutoTaggingFailures displays renders coordinate-organizer failures in Debug tab*/
export const AutoTaggingAudit: React.FC<AutoTaggingFailures.Props> = ({ auditEvents }) => {
  const filtered = auditEvents
    .filter(event => event.type === 'FAILED_TAB_EXTRACTION')
    .map(
      event =>
        event.meta as {
          docLosType: string;
          documentID: string;
          reason: string;
          originalClosingDesignation: string;
        },
    );
  const rows = filtered.map(({ docLosType, documentID, reason, originalClosingDesignation }) => {
    return [
      <Text id={`docId-${documentID}`} key={`docId-${documentID}`}>
        {documentID}
      </Text>,
      <Text key={`docLosType-${documentID}`}>{docLosType}</Text>,
      <Text key={`originalClosingDesignation-${documentID}`}>{originalClosingDesignation}</Text>,
      <Text key={`reason-${documentID}`}>{reason}</Text>,
    ];
  });
  return (
    <LenderTable
      columnWidths={[1, 1, 1, 4]}
      headerTexts={['DOCUMENT ID', 'DOCUMENT', 'ORIGINAL DESIGNATION', 'REASON']}
      id="autoTaggingFailures-table"
      rightAlignLastCol={false}
      sections={rows}
    />
  );
};
